import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Col, Row } from 'react-grid-system';
import H1 from '../../atoms/title/H1';
import Panel from '../../atoms/Panel';
import Layout from '../../templates/Layout';
import SideBar from '../../organisms/dossier/SideBar';
import Tabs from '../../organisms/dossier/Tabs';
import { Helmet } from 'react-helmet';
import ClaimTable from '../../organisms/table/ClaimTable';
import { useTranslation } from 'react-i18next';
const Claim = ({ dossier, claim }) => {
    const { t } = useTranslation();
    return (_jsxs(Layout, { dossierNumber: dossier.id, children: [_jsx(Helmet, { children: _jsxs("title", { children: ["Gegevens - ", t('dossier.title')] }) }), _jsxs(H1, { "data-testid": "title", children: [t('dossier.title'), " ", dossier.id] }), _jsxs(Row, { children: [_jsx(Col, { sm: 9, children: _jsxs(Panel, { children: [_jsx(Tabs, { dossier: dossier }), _jsx(ClaimTable, { claim: claim })] }) }), _jsx(Col, { sm: 3, children: _jsx(SideBar, { dossier: dossier }) })] })] }));
};
export default Claim;
